import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { WorkspaceStaff } from "../types/workspaces.interface";

interface WorkspaceState {
  staff: WorkspaceStaff[];
}

const initialState: WorkspaceState = {
  staff: [],
};

export const workspaceSlice = createSlice({
  name: "workspace",
  initialState,
  reducers: {
    setStaff: (state, action: PayloadAction<WorkspaceStaff[]>) => {
      state.staff = action.payload;
    },
  },
});

export const { setStaff } = workspaceSlice.actions;

export default workspaceSlice.reducer;
